/* localStorage adapter with the same async API the mobile progress service uses. */
export async function getAsyncStorageItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export async function setAsyncStorageItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* quota / private mode — progress is best-effort */
  }
}
